export type Tab = "home" | "invest" | "portfolio" | "settings";

const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: "home", label: "Home", icon: "🏠" },
  { id: "invest", label: "Invest", icon: "📈" },
  { id: "portfolio", label: "Portfolio", icon: "💼" },
  { id: "settings", label: "Settings", icon: "⚙️" },
];

export function TabBar({ tab, onChange }: { tab: Tab; onChange: (t: Tab) => void }) {
  return (
    <nav className="tabbar">
      {TABS.map((t) => (
        <button key={t.id} className={`tab ${tab === t.id ? "active" : ""}`} onClick={() => onChange(t.id)}>
          <span className="icon">{t.icon}</span>
          {t.label}
        </button>
      ))}
    </nav>
  );
}
